<!-- ============================================================== -->
<!-- Blank layout: content only -->
<!-- ============================================================== -->
<div class="blank-layout blank-layout--full">
  <div class="blank-layout__content" [ngClass]="{
      'cardBorder': options.cardBorder,
      orange_theme: options.activeTheme == 'orange_theme',
      blue_theme: options.activeTheme == 'blue_theme',
      aqua_theme: options.activeTheme == 'aqua_theme',
      purple_theme: options.activeTheme == 'purple_theme',
      green_theme: options.activeTheme == 'green_theme',
      cyan_theme: options.activeTheme == 'cyan_theme'
    }" [dir]="options.dir!">
    <router-outlet></router-outlet>
  </div>
</div>
